import Button from '@doordash/component-button'
import { Text, StackChildren } from '@doordash/design-language'
import * as React from 'react'
import { connect } from 'react-redux'
import * as events from '../../../events'
import AddBankAccountModal from '../../molecules/add-bank-account-modal'
import { paymentSetup } from './strings'
import { isFeatureFlagEnabled } from '@doordash/lib-feature-flags'
import * as Exp from '../../../experimentConstants'

type PaymentSetupStepProps = {
  isActive: boolean
  isComplete: boolean
  uniqueLink: string
  stripe: any
  trackConfirmationPageTapDownloadApp?: () => Promise<any>
  trackConfirmationPageClick?: (name: string) => Promise<any>
}

type PaymentSetupStepState = {
  isShowingModal: boolean
}
class PaymentSetupStep extends React.Component<
  PaymentSetupStepProps,
  PaymentSetupStepState
> {
  public state = {
    isShowingModal: false,
  }

  public toggleModal(e) {
    e.stopPropagation()
    const isShowingModal = !this.state.isShowingModal

    this.setState({
      isShowingModal,
    })
  }
  public render() {
    const { isActive, stripe } = this.props
    const paymentSetupSection = (
      <React.Fragment>
        <Text style={Text.Styles.SectionSubtext}>
          {paymentSetup.titleSubtext()}
        </Text>
        <Button
          type={Button.Types.PrimaryPill}
          size={Button.Sizes.Small}
          tag="a"
          onClick={e => {
            this.props.trackConfirmationPageClick('add_bank_account_button')
            this.toggleModal(e)
          }}
          isInline
        >
          {paymentSetup.addBankAccount()}
        </Button>
        {this.state.isShowingModal && (
          <AddBankAccountModal
            uniqueLink={this.props.uniqueLink}
            onClose={this.toggleModal.bind(this)}
            stripe={stripe}
            isW2Dasher={isFeatureFlagEnabled(Exp.W_MODEL_EXPERIMENT)}
          />
        )}
      </React.Fragment>
    )

    const futurePaymentSetup = (
      <Text style={Text.Styles.SectionSubtext}>{paymentSetup.future()}</Text>
    )

    return (
      <StackChildren>
        {isActive ? paymentSetupSection : futurePaymentSetup}
      </StackChildren>
    )
  }
}
const mapDispatchToProps = {
  trackConfirmationPageTapDownloadApp:
    events.trackConfirmationPageTapDownloadApp,
  trackConfirmationPageClick: events.trackConfirmationPageClick,
}
export default connect(null, mapDispatchToProps)(PaymentSetupStep)
